export default __webpack_public_path__ + "static/media/risk-active.7ccb860e.svg";